import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@shared/modules';
import { MatChipsModule } from '@angular/material/chips';
import { ITelemetryItemDTO } from '@core/dto/telemetry.dto';
import { Router } from '@angular/router';

@Component({
    selector: 'app-vehicle-telemetry-card',
    templateUrl: './vehicle-telemetry-card.component.html',
    styleUrls: ['./vehicle-telemetry-card.component.scss'],
    standalone: true,
    imports: [CommonModule, MaterialModule, MatChipsModule],
})
export class VehicleTelemetryCardComponent {
    readonly #router = inject(Router);

    @Input({ required: true }) item!: ITelemetryItemDTO;
    @Input() showVehicleInfo: boolean = true;

    isOlderThan48Hours(date: string | null): boolean {
        if (!date) return true;
        const dateObj = new Date(date);
        const now = new Date();
        const diffInHours = (now.getTime() - dateObj.getTime()) / (1000 * 60 * 60);
        return diffInHours > 48;
    }

    hasAnyTelemetryIssue(): boolean {
        return this.isOlderThan48Hours(this.item.telemetry.odometer.updatedAt) ||
               this.isOlderThan48Hours(this.item.telemetry.gps.updatedAt) ||
               this.isOlderThan48Hours(this.item.telemetry.can.updatedAt);
    }

    formatDate(date: string | null): string {
        if (!date) return '-';
        return new Date(date).toLocaleString('es-AR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
}
